import { createSelector } from '@reduxjs/toolkit';

import { AccessRoles } from 'constants/enums';
import { getUserAid } from 'store/oauth/reducer';

const getAllAdmins = (state: IAppState) => {
  return state.groups.groupAdmins.data;
};

const getAllClinicalRoleGids = createSelector([getAllAdmins, getUserAid], (admins, aid) => {
  const admin = admins.find((admin) => admin.aid === aid);
  const gids =
    admin?.roles
      .filter((role) => role.roles.includes(AccessRoles.ADMIN as UserRole))
      .map((role) => role.gid) || [];
  return gids;
});

const getAdminsByGid = (state: IAppState, gid: string) => {
  let admins = [];
  if (gid === 'all') {
    admins = state.groups.groupAdmins.data;
  } else {
    admins = state.groups.groupAdmins.data.filter((admin) =>
      admin.roles.some((role) => role.gid === gid)
    );
  }
  return admins;
};

const getGidsForAdmin = (state: IAppState, aid: string) => {
  return (
    state.groups.groupAdmins.data
      .find((admin) => admin.aid === aid)
      ?.roles.map((role) => role.gid) || []
  );
};

const getDisplayNames = createSelector([getAllAdmins], (admins) => {
  return admins.reduce(
    (acc, admin) => {
      acc[admin.aid] = admin.name;
      return acc;
    },
    {} as Record<string, string>
  );
});

export { getAllAdmins, getAllClinicalRoleGids, getAdminsByGid, getGidsForAdmin, getDisplayNames };
